import { useQuery } from '@tanstack/react-query';
import { dashboardService, FiltrosDashboard } from '../services/dashboardService';

export const useDashboard = (filtros?: FiltrosDashboard) => {
  const {
    data: metrics,
    isLoading,
    error,
    refetch
  } = useQuery({
    // Los filtros van en la clave: al cambiar el rango se piden los totales de ese rango
    queryKey: ['dashboard-metrics', filtros],
    queryFn: () => dashboardService.getMetrics(filtros),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false
  });

  const {
    data: alertas,
    isLoading: isLoadingAlertas,
    error: errorAlertas
  } = useQuery({
    queryKey: ['dashboard-alertas'],
    queryFn: () => dashboardService.getAlertas(),
    staleTime: 60 * 1000,
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false
  });

  const {
    data: estadosPorPiso,
    isLoading: isLoadingEstadosPorPiso,
    error: errorEstadosPorPiso,
    dataUpdatedAt: estadosActualizadosEn
  } = useQuery({
    queryKey: ['dashboard-estados-por-piso'],
    queryFn: () => dashboardService.getEstadosPorPiso(),
    staleTime: 0, // Siempre considerado stale
    refetchOnWindowFocus: true, // Refetch al enfocar la ventana
    retry: 3, // Reintentar 3 veces
    refetchOnMount: true, // Refetch al montar el componente
    refetchInterval: 60000, // Auto-refresco cada 1 minuto para reflejar cambios de QR
    refetchIntervalInBackground: false // No refrescar cuando la pestaña no está visible
  });

  return {
    metrics,
    alertas,
    estadosPorPiso,
    estadosActualizadosEn,
    isLoadingMetrics: isLoading,
    isLoadingEstados: isLoadingEstadosPorPiso || isLoadingAlertas,
    isLoading: isLoading || isLoadingAlertas || isLoadingEstadosPorPiso,
    error: error || errorAlertas || errorEstadosPorPiso,
    refetch
  };
};
